import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { loginRoute } from 'src/app/core/routing/route-names';

@Component({
    selector: 'app-step-registration-successful',
    templateUrl: './step-registration-successful.component.html',
    styleUrls: ['./step-registration-successful.component.scss'],
    imports: [TranslateModule]
})
export class StepRegistrationSuccessfulComponent {

  constructor(private router: Router) { }

  public onLogin(): void {
      this.router.navigate([loginRoute]);
  }
}
